/**
 * Nguồn dữ liệu tùy chỉnh báo cáo
 * pqkhanh 09.08.2024
 */
export default {
  MA_NOIDUNG: 1,
  MA_LINHVUC: 2,
  MA_CHUONG: 3,
  MA_NGUON: 4,
  MA_LOAI: 5,
  MA_KHOAN: 6,
  MA_TCTK: 7,
  MA_TINHCHAT: 8,
};
